import React, { useState, useEffect, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import {
    Layout,
    notification,
    Col,
    Row,
    Table,
    Spin,
    Button,
    Input,
} from "antd";
import { Redirect, useParams } from "react-router-dom";
import { useApp } from "../../../../AppContext";
import * as WetwheelsApi from "../../../../client-swagger/api";
import { ApiResponse } from "../../../../client-swagger/api";
import ReactSignatureCanvas from "react-signature-canvas";

function DashboardBookingClientDisclaimer() {
    const [redirect, setRedirect] = useState<boolean>(false);
    const { jwtToken, userName, authHeaderOptions } = useApp();
    const [manifestData, setManifestData] = useState(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [name, setName] = useState<string>(null);

    const { id } = useParams<{ id: string }>();

    useEffect(() => {
        if (!name) {
            setName(userName);
        }
    }, [userName]);

    const reloadManifest = () => {
        new WetwheelsApi.ManifestApi()
            .manifestBookingIdGet(id, authHeaderOptions)
            .then(({ data, success }: ApiResponse) => {
                if (success) {
                    setManifestData(data);
                }
                setIsLoading(false);
            });
    };

    useEffect(() => {
        if (!id) {
            return;
        }
        // get data and store in a useState
        reloadManifest();
    }, [id]);

    const showSuccess = (message?: string) => {
        notification.success({
            message: "Success",
            description: message,
        });
    };

    const showError = (message?: string) => {
        notification.error({
            message: "Error",
            description: message,
        });
    };

    const columns = [
        {
            title: "First name",
            dataIndex: "firstName",
            key: "firstName",
        },
        {
            title: "Last name",
            dataIndex: "lastName",
            key: "lastName",
        },
        {
            title: "Photo consent?",
            dataIndex: "hasGivenPhotoConsent",
            key: "hasGivenPhotoConsent",
            render: (value: boolean) => {
                return value ? "Yes" : "No";
            },
        },
    ];

    let sigPad: ReactSignatureCanvas = null;

    const handleClearSig = () => {
        if (sigPad) {
            sigPad.clear();
        }
    };

    const handleSaveForm = () => {
        // actaully do stuff :Facepalm:

        new WetwheelsApi.BookingApi()
            .disclaimerComplete(
                {
                    bookingId: id,
                    disclaimertext:
                        "This should be read from settings, somewhere, somehow",
                    signatureBase64String: sigPad.toDataURL(),
                    signedBy: name,
                },
                authHeaderOptions,
            )
            .then(({ success, message }: ApiResponse) => {
                if (success) {
                    showSuccess("Thank you for signing the disclaimer");
                    setTimeout(() => {
                        setRedirect(true);
                    }, 2000);
                    return;
                }

                showError(message);
            });
    };

    const topRef = useRef<HTMLDivElement>();

    useEffect(() => {
        topRef.current.scrollIntoView();
    }, []);

    const handleNameChange = (e: any) => {
        setName(e.target.value);
    };

    return redirect ? (
        <Redirect to={`/dashboard/bookings/${id}`} />
    ) : (
        <div ref={topRef}>
            <Spin spinning={isLoading}>
                <Layout>
                    <Layout.Content>
                        <Row gutter={[16, 52]}>
                            <Col md={{ span: 18 }} xs={{ span: 24 }}>
                                <h2>TERMS & CONDITIONS</h2>
                                <h3>Consent to powerboating activities</h3>
                                <p>
                                    I agree that my group/family may take part
                                    in a trip on Wetwheels and that the
                                    particulars given are correct and complete
                                    in all respects.
                                </p>
                                <p>
                                    I also have authority to sign on behalf of
                                    my group/family.
                                </p>
                                <p>
                                    All bookings are subject to our terms and
                                    conditions shown below:
                                </p>
                                <h3>Cancellation</h3>
                                <p>
                                    <b>Cancellation by Wetwheels Jersey</b>
                                </p>
                                <p>
                                    The trip may be cancelled or postponed in
                                    the event of bad weather or, very rarely,
                                    due to unforeseen circumstances. The Skipper
                                    will make the decision and his word will be
                                    final. In these circumstances we will give
                                    you as much notice as possible.
                                </p>
                                <p>
                                    In the event of a cancellation the guest
                                    will be welcome to move the booking to
                                    another date{" "}
                                    <b>
                                        SUBJECT TO AVAILABILITY – (PLEASE BE
                                        AWARE THAT AN ALTERNATIVE DATE MAY NOT
                                        BE AVAILABLE)
                                    </b>
                                </p>
                                <h3>Cancellation by </h3>
                                <p>
                                    In all cases, we will try and reschedule the
                                    trip if we can.
                                </p>
                                <p>
                                    <b>Late arrival:</b> we will do what we can
                                    to delay the trip, but this is entirely at
                                    the skipper's discretion. This could result
                                    in you missing the trip.
                                </p>
                                <h3>Participants</h3>
                                <p>
                                    Any person under the age of 18 must be
                                    accompanied by an adult (someone over 18
                                    years).
                                </p>
                                <p>
                                    Any person unable to live independently must
                                    be accompanied by an adult who is
                                    experienced to take care of their personal
                                    and social needs. Group leaders need also to
                                    consider the ratio of carers to disabled
                                    participants is sufficient for the overall
                                    safety and wellbeing of the group in the
                                    event of an emergency. A group leader is
                                    anyone from a third-party organisation who
                                    is identified on the day with responsibility
                                    for their group.
                                </p>
                                <h3>Important Medical Information</h3>
                                <p>
                                    Boating is not suitable for anyone who is
                                    pregnant or is suffering from back problems.
                                    Clients with a pre-existing medical
                                    condition should check with their GP before
                                    embarking and must advise Wetwheels xxx of
                                    any such condition when booking. If you have
                                    an existing medical condition such as
                                    osteoporosis, musculoskeletal injury or any
                                    other physical disability which may prevent
                                    you from safely enjoying or participating in
                                    the trip please contact us in advance to
                                    establish if this trip is suitable.
                                </p>
                                <h3>
                                    Alcohol, drugs or behaviour compromising
                                    safety
                                </h3>
                                <p>
                                    Any participant who has consumed too much
                                    alcohol or is under the influence of drugs
                                    causing impaired reaction or displaying
                                    behaviour likely to compromise safety - will
                                    not be allowed to board the boat. Wetwheels
                                    Jersey reserves the right to terminate your
                                    booking at any time if the behaviour of any
                                    of your party is unacceptable or fails to
                                    follow the instructions of the Skipper. All
                                    clients must accept all instructions and
                                    decisions given to them by the Skipper at
                                    all times whilst on board the vessel or
                                    ashore, for the duration of the booking. A
                                    Skipper's authority is total under maritime
                                    law. If for whatever reason a client does
                                    not accept an order from the Skipper or his
                                    designated substitute, whether the client
                                    considers it to be reasonable or not, the
                                    client shall be considered to be in breach
                                    of his Article of Sailing. The Skipper shall
                                    take any action he considers fit for the
                                    wellbeing of the vessel and crew. If the
                                    client is placed ashore at the nearest port,
                                    no liability whatsoever shall attach to
                                    Wetwheels Jersey.
                                </p>
                                <h3>Personal Effects and valuables </h3>
                                <p>
                                    You are solely responsible for your personal
                                    belongings whilst travelling with us. Any
                                    valuables taken aboard Wetwheels Jersey are
                                    done so entirely at your own risk, and we
                                    accept no responsibility for them
                                    whatsoever. Particular care should be taken
                                    with mobile phones, camera equipment and any
                                    valuables and steps to avoid them getting
                                    wet or lost overboard should be taken if you
                                    choose to take them on board.
                                </p>
                                <h3>Data Protection</h3>
                                <p>
                                    For data protection purposes, the data
                                    controller is Wetwheels Jersey and the data
                                    protection officer is Dina Rogan. Wetwheels
                                    Jersey may share your data with the
                                    Wetwheels Foundation and other agencies such
                                    as the local authority, funding bodies,
                                    other voluntary agencies and where it is
                                    required to do so by law or other
                                    regulation.
                                </p>
                                <p>
                                    We collect all or some of the following
                                    personal information about each Participant:
                                </p>
                                <p>
                                    Name, address, contact telephone number,
                                    age, gender, if they have a disability,
                                    whether they are a wheelchair user or not,
                                    email address, where appropriate and whether
                                    or not consent is given to the taking of
                                    photographs and sharing them on social
                                    media. We also collect personal information
                                    from our participant feedback forms/surveys.
                                </p>
                                <p>
                                    The information given by you will be used
                                    solely by us in order to process your
                                    booking and carry out our contractual
                                    obligations in relation to your booking.
                                    Your data will be stored for our use, being
                                    kept as a record of your trip on Wetwheels
                                    Jersey for insurance purposes. We will keep
                                    your personal data for an initial period of
                                    6 years after the date of your trip at which
                                    point, we will give consideration to our
                                    obligations with regard to data
                                    minimisation.
                                </p>
                                <p>
                                    Your data will only be accessible by
                                    authorised staff and volunteers or as
                                    otherwise permitted by law.
                                </p>
                                <p>
                                    To the best of our information, knowledge
                                    and belief, your personal data is not
                                    transferred outside of the EEA.
                                </p>
                                <p>
                                    As a data subject, you have the following
                                    rights in respect of your own personal data:{" "}
                                    <a
                                        href="https://www.gov.je/Government/dataprotection/pages/dataprotectioninjersey.aspx"
                                        target="_blank"
                                        style={{ textDecoration: "underline" }}
                                    >
                                        CLICK HERE
                                    </a>
                                </p>
                                <p>
                                    If you would like to know more or wish to
                                    make a complaint about any aspect of the
                                    processing of your personal data by us, then
                                    please write to Dina Rogan, C/O The Croft,
                                    Bagatelle Road, St Saviour, JE2 7TY.
                                </p>
                                <h3>Photography</h3>
                                <p>
                                    Everyone has a great time on board, and we
                                    like to use photographs on our social media
                                    pages to show people what we do.{" "}
                                    <b>
                                        We ask for your consent to these
                                        activities on our booking form.
                                    </b>
                                </p>
                                <p>
                                    Because of the changes in data protection
                                    laws, we treat photographs very carefully.
                                    As a result, we have to ask your permission
                                    to use the photographs and want you to be
                                    clear on where and how we use them.
                                </p>
                                <p>
                                    Please ensure you have completed details for
                                    all participants of your group/family
                                </p>
                                <p>
                                    By giving your permission for a participant,
                                    you grant Wetwheels Jersey, Wetwheels
                                    Operators and the Wetwheels Foundation,
                                    permission to take photographs and full
                                    rights to use the images resulting from the
                                    photography/video filming, and any
                                    reproductions or adaptations of the images
                                    on our social media pages, including for
                                    fundraising, publicity or other purposes to
                                    help achieve the group's aims. This might
                                    include (but is not limited to), the right
                                    to use them in our printed and online
                                    publicity, social media, press releases and
                                    funding applications.
                                </p>
                                <p>
                                    You understand that you can withdraw your
                                    consent at any time but acknowledge that
                                    once on social media, Wetwheels Jersey
                                    cannot reasonably be expected to remain in
                                    control of the images.
                                </p>
                                <p>
                                    If you wish to take your own photographs,
                                    please be mindful of our other participants
                                    and ensure that only the children under your
                                    direct care are pictured in the image.
                                </p>
                                <h3>Safety </h3>
                                <p>
                                    All participants will be given a full safety
                                    briefing by the skipper, immediately prior
                                    to departure. All participants are required
                                    to pay attention to the safety information
                                    given. Please make the skipper aware of any
                                    medical conditions or disabilities that may
                                    affect you or a member of your group whilst
                                    aboard. Details can be given privately by
                                    speaking to the skipper/Crew on arrival or
                                    at the time of booking.
                                </p>
                                <h3>Injury</h3>
                                <p>
                                    We will file a MAIB (Marine Accident
                                    Investigation Branch) report for any
                                    significant injuries or accidents sustained
                                    whilst afloat and any minor injury or
                                    'near-miss' will be recorded and filed.
                                    Please immediately inform the skipper of any
                                    injury sustained as soon as it happens in
                                    order that that we can adequately assess the
                                    situation, offer first aid where necessary
                                    or summon further medical assistance. Please
                                    inform the Skipper if you experience any
                                    unusual discomfort, which may be indicative
                                    of more significant issues A copy of our
                                    Risk Assessments and Insurance Policy can be
                                    provided on request.
                                </p>
                                <h3>The Skipper's decision</h3>
                                <p>
                                    The skipper's decision on marine and safety
                                    matters is final. Skippers do not have the
                                    authority to negotiate any business /
                                    settlement terms or resolve disputes. Any
                                    dispute or query should be addressed to the
                                    CEO at our head office at: The Victory, Land
                                    Sec, Gunwharf Quays House, Gunwharf Quays,
                                    Portsmouth, Hampshire PO1 3TZ or call 023 92
                                    819366.
                                </p>
                                <h2>RISK ACKNOWLEDGEMENT & DISCLAIMER</h2>
                                <p>
                                    Due to the nature of the activity, you are
                                    requested to read the following and sign to
                                    confirm that you have received and
                                    understood it along with our terms and
                                    conditions.
                                </p>
                                <p>
                                    Please ask if there is anything that you do
                                    not understand or require further
                                    information.
                                </p>
                                <p>
                                    The Skipper/Crew will deliver a full safety
                                    briefing prior to departure for your own
                                    safety, and will instruct on how to board,
                                    where to sit and what to do in an emergency.
                                    If you do not fully understand what you have
                                    been told, <b>please ask.</b>
                                </p>
                                <p>
                                    It must be recognised that Powerboating by
                                    its nature is an unpredictable sport and
                                    therefore inherently involves an element of
                                    risk with being on the water. By taking part
                                    and coming aboard Wetwheels, you agree and
                                    acknowledge that:
                                </p>
                                <ol
                                    className="mb-l"
                                    style={{
                                        listStyleType: "upperRoman",
                                    }}
                                >
                                    <li>
                                        You are aware of and accept the inherent
                                        element of risk involved and you hereby
                                        accept responsibility for yourself and
                                        for the individual(s) in your care at
                                        all times.
                                    </li>
                                    <li>
                                        The skipper is advised of any concerns
                                        you have prior to boarding.
                                    </li>
                                    <li>
                                        The wearing of Lifejackets is{" "}
                                        <b>mandatory</b> on all trips.
                                    </li>
                                </ol>
                                <p>
                                    For those of you who are able-bodied or
                                    wheelchair users who do not use a chest
                                    strap, your lifejackets are{" "}
                                    <b>automatically self-inflating</b> and in
                                    the unlikely event you find yourself in the
                                    water, your lifejacket will automatically
                                    inflate, if it doesn't, you'll need to pull
                                    the red manual inflation toggle.
                                </p>
                                <p>
                                    If you are a wheelchair user who does use a
                                    chest strap, you will be fitted with a{" "}
                                    <b>manual inflating lifejacket</b>
                                    {""}. This is for your safety and to prevent
                                    injury in the unlikely event the lifejacket
                                    self inflates in a non-emergency situation.
                                    You or your caregiver will be given
                                    instructions on what to do in the event of
                                    an emergency and how to pull the red manual
                                    inflation toggle.
                                </p>
                                <p>
                                    Lifejackets will require adjustment to fit
                                    correctly, and our Skipper and Crew will
                                    assist as necessary.
                                </p>
                                <p>
                                    We also suggest that ladies do not wear
                                    dresses or skirts, as you will be asked to
                                    wear lifejackets with crutch straps.
                                    Wheelchair users will also be required to
                                    wear crutch strap where possible to do so.
                                </p>
                                <ol
                                    className="mb-l"
                                    start={4}
                                    style={{
                                        listStyleType: "upperRoman",
                                    }}
                                >
                                    <li>
                                        <b>
                                            You will remain seated whilst
                                            underway and hold on firmly at all
                                            times.
                                        </b>{" "}
                                        If at any time you or a member or your
                                        group feels unwell, uncomfortable,
                                        experience any pain or feel any
                                        distress, please notify the skipper/crew
                                        <b>immediately.</b>
                                    </li>
                                    <li>
                                        You accept responsibility for any
                                        injury, damage or loss to the extent
                                        caused by your own negligence.
                                    </li>
                                    <li>
                                        Nothing in these Terms and Conditions
                                        shall exclude the responsibility of
                                        Wetwheels for any foreseeable and
                                        reasonable loss, injury, or damage
                                        directly caused by its negligence and/or
                                        that of its employees. Such
                                        responsibility shall be capped at the
                                        level set out in our Public Liability
                                        insurance.
                                    </li>
                                </ol>
                                <p>
                                    <b>
                                        You may get wet while participating in
                                        this activity:
                                    </b>{" "}
                                    This can vary considerably according to the
                                    weather conditions or sea state on the day
                                    and is completely beyond our control. Spray
                                    capes can be provided to cover your clothes,
                                    if you would like one, <b>please ask.</b>
                                </p>
                                <p>
                                    By receipt of this form and boarding the
                                    Wetwheels Jersey vessel, I confirm that, on
                                    behalf of my group/family, and myself we
                                    have read and fully understand the Terms and
                                    Conditions and agree to abide by them and
                                    will comply with all the instructions given
                                    to us.
                                </p>
                            </Col>
                            <Col md={{ span: 18 }} xs={{ span: 24 }}>
                                {manifestData && manifestData.passengers && (
                                    <Table
                                        pagination={false}
                                        dataSource={manifestData.passengers}
                                        columns={columns}
                                    />
                                )}
                            </Col>
                            <Col md={{ span: 18 }} xs={{ span: 24 }}>
                                <div className="mb-m">
                                    <h3>
                                        I have read and acknowledge this
                                        disclaimer
                                    </h3>
                                    <p>Please print your full name</p>

                                    <Col md={{ span: 9 }} xs={{ span: 12 }}>
                                        <Input
                                            size="large"
                                            onChange={handleNameChange}
                                            name="name"
                                            placeholder="Please enter your name"
                                        />
                                    </Col>
                                </div>
                                <div className="mb-m">
                                    <p>
                                        Please use your mouse or finger to sign
                                        your consent
                                    </p>
                                    <SignatureCanvas
                                        ref={(ref) => {
                                            sigPad = ref;
                                        }}
                                        penColor="grey"
                                        canvasProps={{
                                            width: 700,
                                            height: 250,
                                            className: "a-sigCanvas",
                                        }}
                                    />
                                </div>
                                <Button
                                    onClick={handleClearSig}
                                    htmlType="button"
                                    size="small"
                                >
                                    Clear and start again
                                </Button>
                            </Col>
                        </Row>
                    </Layout.Content>
                    <Layout.Footer
                        style={{
                            padding: 0,
                            background: "none",
                            width: "100%",
                        }}
                    >
                        {/* <Link to="/dashboard/bookings/detail?id=JRY9764">
            <button className="a-button v-button-primary">Back</button>
          </Link> */}
                        <Button
                            className="a-button v-button-primary "
                            onClick={handleSaveForm}
                            htmlType="button"
                        >
                            Save
                        </Button>
                    </Layout.Footer>
                </Layout>
            </Spin>
        </div>
    );
}

export default DashboardBookingClientDisclaimer;
